import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem, Badge, Button, Input } from "reactstrap";
import { ClipLoader } from "react-spinners";

function UnitStudentsModal({
  isOpen,
  onClose,
  usersCompany = [],
  onOpenStudentHistory,
  studentHistoryLoading = false,
  activeStudentId = null
}) {
  const [searchValue, setSearchValue] = React.useState("");
  const students = Array.isArray(usersCompany)
    ? usersCompany.filter(user => {
        if (!user) return false;
        if (user.roleKey) return user.roleKey === "student";
        const level = Number(user.accessLevel);
        return level === 4;
      })
    : [];

  const term = (searchValue || "").trim().toLowerCase();
  const filteredStudents = students
    .filter(student => {
      if (!term) return true;
      const fields = [student.name, student.lastName, student.email, student.username];
      return fields.filter(Boolean).map(v => v.toString().toLowerCase()).some(v => v.includes(term));
    })
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered className="modal-dialog-scrollable">
      <ModalHeader toggle={onClose}>Alunos da unidade ({filteredStudents.length})</ModalHeader>
      <ModalBody>
        {students.length > 0 ? (
          <>
            <Input type="search" value={searchValue} onChange={e => setSearchValue(e.target.value)} placeholder="Pesquisar por nome, e-mail ou usuário" className="mb-3" />
            {filteredStudents.length > 0 ? (
              <ListGroup flush>
                {filteredStudents.map(student => {
                  const isActiveLoading = studentHistoryLoading && activeStudentId && String(activeStudentId) === String(student.id);
                  return (
                    <ListGroupItem key={student.id} className="d-flex justify-content-between align-items-center py-2">
                      <div className="d-flex align-items-center">
                        <div className="mr-3" style={{ width: "48px", height: "48px", borderRadius: "50%", overflow: "hidden" }}>
                          <img src={student.photo || "/images/defaultAvatar.png"} alt="Aluno" className="rounded-circle" style={{ width: "48px", height: "48px", objectFit: "cover" }} />
                        </div>
                        <div>
                          <div className="font-weight-bold">{student.name} {student.lastName}</div>
                          <div className="small text-muted">{student.email || "Sem e-mail"}{student.email ? " • " : ""}ID {student.id}</div>
                          <div className="small text-muted d-flex align-items-center">
                            <span>{student.roleLabel || "Aluno"}</span>
                            <Badge color={student.isBlocked ? "danger" : "success"} pill className="ml-2">{student.statusLabel || (student.isBlocked ? "Bloqueado" : "Ativo")}</Badge>
                          </div>
                        </div>
                      </div>
                      <Button size="sm" color="primary" onClick={() => onOpenStudentHistory && onOpenStudentHistory(student)} disabled={studentHistoryLoading && (!activeStudentId || String(activeStudentId) !== String(student.id))}>
                        {isActiveLoading ? <ClipLoader size={14} color="#fff" /> : "Ver histórico"}
                      </Button>
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            ) : (
              <div className="text-center text-muted py-4">Nenhum aluno corresponde à pesquisa.</div>
            )}
          </>
        ) : (
          <div className="text-center text-muted py-4">Nenhum aluno encontrado para esta unidade.</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>Fechar</Button>
      </ModalFooter>
    </Modal>
  );
}

export default UnitStudentsModal;
